module.exports = __webpack_public_path__ + "static/img/mulan.f01648e9.png";